"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = reusePromise;
exports.clear = clear;
exports.decorator = decorator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _allPromiseMapsByArgs = [];

function serializeArguments(key) {
  return (0, _stringify2.default)(key);
}

function reusePromise(origFn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = (0, _extends3.default)({
    memoize: false,
    serializeArguments: serializeArguments
  }, options);

  var promiseMapsByArgs = {};

  var wrappedFn = function wrappedFn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var key = options.serializeArguments(args);

    var pendingPromise = promiseMapsByArgs[key];

    if (pendingPromise) return pendingPromise;

    var forgetPromise = function forgetPromise() {
      return delete promiseMapsByArgs[key];
    };

    var origPromise = origFn.apply(this, args);

    var promise = origPromise.then(function (value) {
      if (!options.memoize) forgetPromise();
      return value;
    }, function (err) {
      forgetPromise();
      throw err;
    });
    promiseMapsByArgs[key] = promise;

    return promise;
  };

  wrappedFn.__reusePromise__origFn = origFn;
  wrappedFn.__reusePromise__clear = function () {
    reusePromise.clear(wrappedFn);
  };
  wrappedFn.__reusePromise__promiseMapsByArgs = promiseMapsByArgs;
  _allPromiseMapsByArgs.push(promiseMapsByArgs);

  return wrappedFn;
}

function clearObject(object) {
  (0, _keys2.default)(object).forEach(function (k) {
    return delete object[k];
  });
}

function clear() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  if (fn === undefined) {
    _allPromiseMapsByArgs.forEach(clearObject);
  } else {
    clearObject(fn.__reusePromise__promiseMapsByArgs);
  }
}

function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (target, name, descriptor) {
    descriptor.value = reusePromise(descriptor.value, options);
    return descriptor;
  };
}

decorator.clear = clear;
reusePromise.clear = clear;